import { Component, OnInit, Inject, ViewContainerRef, ViewChild, Renderer, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, of } from 'rxjs';
import { BackgroundDashboardService } from '../../shared/services/backgroundDashboard.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'app-impress-employer-dialog',
    templateUrl: './impressEmployerDialog.component.html',
})
export class ImpressEmployerDialogComponent implements OnInit, OnDestroy {
    public myForm = [];
    public UserEnterEmailId = '';
    public AddInputArray: any = [1];
    public i = 1;
    ArrayToStoreEmailFromMultipleInput = [];
    public GetOrderDetails = [];
    public IsSenderMailSend = false;
    public EmailValue = '';
    public DisabledShareButton = false;
    public IsErrorMsg = false;
    public IsSpinnerProgress = false;
    // @ViewChild('fieldName1')
    // fieldName1: any;


    constructor(public dialogRef: MatDialogRef<ImpressEmployerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef,
        private _BackgroundDashboardService: BackgroundDashboardService, private fb: FormBuilder,
        private renderer: Renderer, private snackBar: MatSnackBar) {
        dialogRef.disableClose = true;
        this.GetOrderStatus();
        this.GetOrderReportDetails();
    }

    ngOnInit() { }

    onNoClick(): void {
        this.dialogRef.close();
    }

    // Get the Status Of the Order
    GetOrderStatus() {
        this._BackgroundDashboardService.GetStatusOfOrder(atob(localStorage.getItem('OrderId'))).
            subscribe(res => this.GetOrderStatusSucess(res),
                res => this.GetOrderStatusError(res));
    }

    GetOrderStatusSucess(res) {
        if (res !== 'Completed') {
            this.DisabledShareButton = false;

        } else {
            this.DisabledShareButton = true;
        }
    }

    GetOrderStatusError(res) { }

    // Send Report on selected email
    ImpressEmployerShareNow() {
        const ArrayOfEmail = this.ArrayToStoreEmailFromMultipleInput.map(x => x.Email);
        this.UserEnterEmailId = ArrayOfEmail.join(';');
        if (this.UserEnterEmailId !== '') {
            this.IsSpinnerProgress = true;
            this._BackgroundDashboardService.ImpressEmployerGenerateEmail(this.UserEnterEmailId, localStorage.
                getItem('Email')).subscribe(res => this.ImpressEmployerGenerateEmailSucess(res),
                    res => this.ImpressEmployerGenerateEmailError(res));
        } else {
            this.IsErrorMsg = true;
        }
    }

    ImpressEmployerGenerateEmailSucess(res) {
        this.EmailValue = null;
        this.GetOrderReportDetails();
        this.IsSpinnerProgress = false;
        const snackBarRef = this.snackBar.open('Your mail sent sucessfully.',
            'OK', {
                panelClass: ['hideMe'], // added hideMe class in the style.scss for fade in and out
                verticalPosition: 'bottom'
            }
        );
    }

    ImpressEmployerGenerateEmailError(res) { }

    // Add Input for multiple Send Email
    AddInput() {
        this.AddInputArray.push(this.i++);
    }

    // Set Multiple email
    SetValue(event, i) {
        if (this.ArrayToStoreEmailFromMultipleInput.length <= i) {
            this.ArrayToStoreEmailFromMultipleInput.push({ Email: event.target.value });
        } else {
            this.ArrayToStoreEmailFromMultipleInput[i].Email = event.target.value;
        }
    }

    // Delete Email Input feild
    DeleteInput(index) {
        if (index !== 0) {
            this.AddInputArray.splice(index, 1);
        }
    }

    // added to remove snackbar message if we are going to another page.
    ngOnDestroy() {
        this.snackBar.dismiss();
    }

    // Revoke functinality
    RevokeMail(Id) {
        this._BackgroundDashboardService.RevokeAccesbilityViewOrderReport(Id).
            subscribe(res => this.RevokeAccesbilityViewOrderReportSucess(res),
                res => this.RevokeAccesbilityViewOrderReportError(res));

    }

    RevokeAccesbilityViewOrderReportSucess(res) { }

    RevokeAccesbilityViewOrderReportError(res) { }

    ResendMail(UserEmailId) {
        this.IsSpinnerProgress = true;
        this._BackgroundDashboardService.ImpressEmployerGenerateEmail(UserEmailId, localStorage.
            getItem('Email')).subscribe(res => this.ImpressEmployerGenerateEmailSucess(res),
                res => this.ImpressEmployerGenerateEmailError(res));
    }

    GetOrderReportDetails() {
        this._BackgroundDashboardService.GetOrderReportDetails(localStorage.
            getItem('Email')).subscribe(res => this.GetOrderReportDetailsSucess(res),
                res => this.GetOrderReportDetailsError(res));
    }

    GetOrderReportDetailsSucess(res) {
        this.GetOrderDetails = res;
        this.IsSenderMailSend = false;
        if (this.GetOrderDetails.length > 0) {
            this.IsSenderMailSend = true;
        }


    }

    GetOrderReportDetailsError(res) { }
}
